import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-annule-bon-liv-negoce',
  templateUrl: './annule-bon-liv-negoce.component.html',
  styleUrls: ['./annule-bon-liv-negoce.component.scss']
})
export class AnnuleBonLivNegoceComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterOrdersByStatus('Tous');
    }

}
